import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState: {
  qualityScoreCategories: {
    label: string;
    values: {
      name: string;
      id: string;
      order: number;
    }[];
  };
  errorMessage: string;
  error: boolean;
  loading: boolean;
} = {
  qualityScoreCategories: {
    label: "",
    values: [],
  },
  error: false,
  loading: false,
  errorMessage: "",
};
const fetchQualityScoreCategories = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_QUALITY_SCORE_CATEGORIES_SUCCESS: {
      console.log("action.qualityScoreCategories", action.qualityScoreCategories);
      return updateObject(state, {
        qualityScoreCategories: action.qualityScoreCategories,
        error: false,
        loading: false,
        errorMessage: "",
      });
    }
    case actionTypes.FETCH_QUALITY_SCORE_CATEGORIES_STARTED:
      return updateObject(state, {
        qualityScoreCategories: initialState.qualityScoreCategories,
        error: false,
        loading: true,
        errorMessage: "",
      });

    case actionTypes.FETCH_QUALITY_SCORE_CATEGORIES_FAILED:
      return updateObject(state, {
        qualityScoreCategories: initialState.qualityScoreCategories,
        error: true,
        loading: false,
        errorMessage: action.errorMessage,
      });

    case actionTypes.RESET_FETCH_QUALITY_SCORE_CATEGORIES:
      return updateObject(state, {
        qualityScoreCategories: initialState.qualityScoreCategories,
        error: initialState.error,
        loading: initialState.loading,
        errorMessage: initialState.errorMessage,
      });

    default:
      return state;
  }
};

export default fetchQualityScoreCategories;
